import { CSSProperties } from 'react'

export const carouselContainer: CSSProperties = {
  display: 'flex',
  width: '352px',
  height: '387px',
  flexDirection: 'column',
  alignItems: 'center',
}

export const carouselImage: CSSProperties = { height: '218px', width: '352px', cursor: 'pointer' }

export const carouselDetails: CSSProperties = {
  background: '#FBFBFB',
  display: 'flex',
  height: '170px',
  width: '100%',
  padding: '20px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  flexShrink: 0,
  alignSelf: 'stretch',
  color: '#5B5B5B',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 400,
}

export const carouselCaption: CSSProperties = {
  color: '#0C0C0C',
  fontSize: '18px',
  fontStyle: 'normal',
  fontWeight: 500,
}

export const closeButton: CSSProperties = {
  position: 'absolute',
  top: '17px',
  right: '17px',
  background: '#FBFBFB',
  width: '30px',
  height: '30px',
}

export const viewDetailButton: CSSProperties = {
  position: 'absolute',
  top: '310px',
  right: '20px',
  textTransform: 'none',
  fontWeight: '700',
  marginTop: '30px',
}
